export type LandingFeature = {
  id: string;
  title: string;
  description: string;
  screenshotSrc: string;
  screenshotAlt: string;
};

export const LANDING_FEATURES: LandingFeature[] = [
  {
    id: 'feed',
    title: 'Browse memories from real places',
    description:
      'Like, comment, and save the spots worth another visit from a feed tied to locations you care about.',
    screenshotSrc: '/screenshots/feed.png',
    screenshotAlt: "I'd Go Back home feed showing a post from Tokyo Tower",
  },
  {
    id: 'create-memory',
    title: 'Share a memory',
    description:
      'Add photos, write a caption, tag the place where it happened, and keep every moment tied to a location on the map.',
    screenshotSrc: '/screenshots/create-post.png',
    screenshotAlt: "I'd Go Back new entry screen for creating a post with photos and location",
  },
  {
    id: 'friends-follow',
    title: 'Follow friends and their places',
    description:
      'Visit profiles, follow people you care about, and explore the memories they have pinned to the map.',
    screenshotSrc: '/screenshots/friends-follow.png',
    screenshotAlt: "I'd Go Back profile screen showing a user's memories and follow button",
  },
  {
    id: 'saved',
    title: 'Build your go-back list',
    description:
      'Save places you want to return to and keep a personal collection of cities, cafés, and corners you do not want to forget.',
    screenshotSrc: '/screenshots/saved-places.png',
    screenshotAlt: "I'd Go Back saved places screen with a personal go-back list",
  },
  {
    id: 'explore',
    title: 'Explore places on the map',
    description:
      'Search locations, filter by category, browse trending spots nearby, and see how many memories live at each place.',
    screenshotSrc: '/screenshots/explore-places.png',
    screenshotAlt: "I'd Go Back explore screen showing search, map, and popular places",
  },
  {
    id: 'following',
    title: 'See only who you follow',
    description:
      'Switch to Following for posts from friends you care about. Dark mode keeps browsing comfortable day or night.',
    screenshotSrc: '/screenshots/following-dark.png',
    screenshotAlt: "I'd Go Back Following feed in dark mode showing a post from Chicago",
  },
  {
    id: 'comments-likes',
    title: 'Like and comment on posts',
    description:
      'Tap into the conversation on any memory. Like posts, reply in comments, and stay connected to the places your friends are sharing.',
    screenshotSrc: '/screenshots/comments-likes.png',
    screenshotAlt: "I'd Go Back comments sheet on a post with likes and replies",
  },
];
